import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "outRelation",
  "use": "outRelation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"outRelation\"><defs><style>#outRelation .cls-1{fill:none}</style></defs><title>资源 21</title><g id=\"outRelation_图层_2\" data-name=\"图层 2\"><g id=\"outRelation_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path d=\"M23.29 8.73L18 3.48a2.48 2.48 0 0 0-3.48 0l-1.46 1.44-2.5-2.49a2.5 2.5 0 0 0-3.48 0L.72 8.72a2.4 2.4 0 0 0 0 3.43l9.55 9.43a2.47 2.47 0 0 0 1.73.7 2.63 2.63 0 0 0 1.75-.7l9.55-9.43a2.43 2.43 0 0 0-.01-3.42zm-4.56 5l-.37.38-.91-.89a.94.94 0 0 0-1.36 0 .9.9 0 0 0-.29.67 1 1 0 0 0 .27.67l.91.91-.75.75-2-2a.93.93 0 0 0-1.35 0 .93.93 0 0 0 0 1.32l2 2-.75.75-3.06-3a.93.93 0 0 0-.67-.28 1 1 0 0 0-1 1 1 1 0 0 0 .27.67l3 3-.38.38a.53.53 0 0 1-.75 0L2.1 10.59a.46.46 0 0 1-.18-.37.53.53 0 0 1 .16-.38l6.36-6.29a.53.53 0 0 1 .38-.16.66.66 0 0 1 .39.17L11.71 6l-.91.89a2.4 2.4 0 0 0 0 3.45l1.06 1a2.47 2.47 0 0 0 3.49 0l.9-.9L18.73 13a.57.57 0 0 1 .16.38.55.55 0 0 1-.16.35z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/outRelation.svg
// module id = w3Rr
// module chunks = 6